import Crud from '../views/User/Crud'
import Entity from '../views/User/Add'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'NewUser',
            component: Entity,
            meta: {
                ability: 'usuarios.gerenciar',
                pageTitle: 'User',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'Add',
                        active: true,
                       
                    },
                ],
            },
        },
        {
            path: '/users/edit/:id?',
            name: 'EditUser',
            component: Entity,
            meta: {
                ability: 'usuarios.gerenciar',
                pageTitle: 'User',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/users',
            name: 'list-users',
            component: Crud,
            meta: {
                ability: 'usuarios.ver',
                pageTitle: 'Users',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                    

                ],
            },
        },
    ]
};


export default routes
